import {
  AgentComponentChangeType,
  AgentComponentField,
  type UnpublishedComponentChange,
} from '@reach/shared-types/agent-components';
import styles from './UnpublishedChangeItem.module.css';

interface UnpublishedChangeItemProps {
  change: UnpublishedComponentChange;
}

const CHANGE_LABELS: Record<AgentComponentChangeType, string> = {
  [AgentComponentChangeType.ADDED]: 'Added',
  [AgentComponentChangeType.REMOVED]: 'Removed',
  [AgentComponentChangeType.EDITED]: 'Edited',
};

const FIELD_LABELS: Record<AgentComponentField, string> = {
  [AgentComponentField.MODE]: 'visibility',
  [AgentComponentField.INSTRUCTIONS]: 'instructions',
  [AgentComponentField.TRIGGER]: 'when to run',
  [AgentComponentField.TOOLS]: 'tools',
  [AgentComponentField.TENANT_NAME]: 'tenant display name',
  [AgentComponentField.TENANT_DESCRIPTION]: 'tenant description',
};

export const UnpublishedChangeItem = ({ change }: UnpublishedChangeItemProps) => {
  const changedFieldNames = change.changedFields.map(field => FIELD_LABELS[field]).join(', ');
  const fieldsWereEdited = changedFieldNames.length > 0;

  return (
    <li className={styles.unpublishedChangeItem}>
      <strong>{change.name}</strong>
      <span className={styles.changeBadge} data-change={change.change}>
        {CHANGE_LABELS[change.change]}
      </span>
      {fieldsWereEdited && <span>{changedFieldNames}</span>}
    </li>
  );
};
